export const myProfile = {
  title: "プロフィール",
  edit: "編集",
  save: "保存",
  cancel: "キャンセル",
  name: "ニックネーム",
  bio: "自己紹介",
  settings: "設定",
  coins: "コイン",
  coinsCard: {
    label: "保有ポイント",
    purchase: "ポイント追加",
  },
  aboutPoints: "ポイントについて",
  gallery: "ギャラリー",
  fleaMarket: "フリマ",
  /** coco+ はフリマを「出品」と呼ぶ */
  cocoplusFleaMarket: "出品",
  videoCallPermission: "ビデオ通話許可",
  voiceCallPermission: "音声通話許可",
  contact: "お問い合わせ",
  logout: "ログアウト",
  logoutConfirm: "ログアウトしますか？",
  changeAvatar: "写真を変更",
  editProfile: "プロフィール編集",
  avatarCoachmark: "プロフィール写真を追加するとマッチ率アップ！",
  editProfileButton: {
    noAvatar: "プロフィール画像が未登録です",
    hasBonus: "プロフィールを設定してポイントゲット",
    hasUnset: "未設定の項目があります",
    complete: "プロフィール編集",
  },
  email: {
    title: "メール・パスワード変更",
    current: "現在のメールアドレス",
    new: "新しいメールアドレス",
    currentPassword: "現在のパスワード",
    newPassword: "新しいパスワード",
    confirmPassword: "パスワード（確認）",
    submit: "変更する",
    success: "メールアドレスとパスワードを変更しました",
    error: {
      incorrectPassword: "パスワードが正しくありません",
      generic: "メールアドレスの変更に失敗しました",
    },
  },
  emailChange: "メールアドレス変更",
  footprint: "足跡",
  favorite: "お気に入り",
  dailyBonus: "デイリーボーナス",
  news: "News",
} as const;
